import { DWT_DEFRA_SUBMISSIONS_TABLE_NAME } from '../../dwt-defra-submissions/dwt-defra-submissions.constants';
import { DWT_DEFRA_SUBMISSIONS_SHEET_COLUMNS } from '../../dwt-defra-submissions/models/dwt-defra-submissions-sheet.model';
import { mapDwtDefraSubmissionApiRecordToRows } from '../../dwt-defra-submissions/utils/map-dwt-defra-submission-api-record-to-rows.util';
import type { TabularSheetPayload } from '../../shared/tabular-sheet-payload.model';

/**
 * Maps Get-RegulatoryReports records into one row per JSON field Trace submitted to DEFRA.
 */
export function formatDwtDefraSubmissionsRecordsToTabularSheet(
    records: unknown[]
): TabularSheetPayload {
    const rows = records.flatMap(mapDwtDefraSubmissionApiRecordToRows);
    return {
        columnHeaders: DWT_DEFRA_SUBMISSIONS_SHEET_COLUMNS.map((column) => column.header),
        rows: rows.map((row) =>
            DWT_DEFRA_SUBMISSIONS_SHEET_COLUMNS.map((column) => row[column.key])
        ),
        tableName: DWT_DEFRA_SUBMISSIONS_TABLE_NAME,
    };
}
